import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const location = useLocation();

  const closeAll = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  // Scrollspy logic: Detects if you are on Qualifications or Registration
  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname === "/Qualifications") {
        const regSection = document.getElementById("registration");
        if (regSection) {
          const rect = regSection.getBoundingClientRect();
          if (rect.top <= 150) {
            setActiveSection("registration");
          } else {
            setActiveSection("qualifications");
          }
        }
      } else {
        setActiveSection("");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); 
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  return (
    <header>
      <div className="header-bg"></div>

      <div className="logo">
        <div className="logo1">
          <img src="pics/bnt.png" alt="BNT Logo" />
        </div>
        <div className="logo2">
          <h1>
            <span className="green">BRODKAST </span>
            <span className="white">NG </span>
            <br /> {/* This creates the second line */}
            <span className="white">TALINO </span>
            <span className="green">2026 </span>
          </h1>
        </div>
      </div>

      <button
        className={`nav-toggle${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav className={`navbar${menuOpen ? " open" : ""}`}>
        <Link to="/" onClick={closeAll}>Home</Link>

        <div className={`dropdown${dropdownOpen ? " open" : ""}`}>
          <button
            className="nav-btn"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            About
          </button>
          <div className="dropdown-menu">
            <Link to="/Schools" onClick={closeAll}>List of Schools</Link>
            <Link to="/Champions" onClick={closeAll}>List of Champions</Link>
            <Link to="/Mechanics" onClick={closeAll}>Quiz Show Mechanics</Link>
            <Link to="/Packages" onClick={closeAll}>Packages</Link>
          </div>
        </div>

        {/* SPLIT LINKS: Qualifications and Registration */}
        <Link 
          to="/Qualifications" 
          onClick={closeAll}
          className={activeSection === "qualifications" ? "active-nav" : ""}
        >
          Qualifications
        </Link>
        
        <Link 
          to="/Qualifications#registration" 
          onClick={closeAll}
          className={activeSection === "registration" ? "active-nav" : ""}
        >
          Registration
        </Link>

        <a 
          href="https://compatible-me.vercel.app/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="nav-link-style" 
          onClick={closeAll}
        >
          Mini Game
        </a>
      </nav>
    </header>
  );
}